<template>
  <div class="navigations">
    <el-form :inline="true"  :model="userForm" :rules="rules" ref="userForm"  label-width="80px">
        <el-form-item label="项目名称" prop="name" label-width="100px">
            <el-input v-model="userForm.name" style="width:223px"></el-input>
        </el-form-item><br>
        <el-form-item label="所属分组" prop="group" label-width="100px">
          <el-select v-model="userForm.group">
            <el-option v-for="role in fenzu" :key="role.id" :label="role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item><br>
        <el-form-item label="部门分组" prop="group" label-width="100px">
          <el-select v-model="optionsname"  size="" :popper-append-to-body="false" class="hello">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        </el-form-item><br>
        <el-form-item label="描述" prop="remark" label-width="100px">
             <el-input v-model="userForm.remark" type="textarea" :rows="4" placeholder="请输入内容" style="width:395px"></el-input>
        </el-form-item><br>
        <el-form-item label="成员" prop="users" label-width="100px">
          <template>
            <el-select
              v-model="userForm.users"
              multiple
              filterable
              default-first-option
              placeholder="请选择成员">
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-form-item><br>
      <el-form-item label="协同负责人" prop="help" label-width="100px">
        <template>
          <el-select
            v-model="userForm.help"
            placeholder="请选择成员">
            <el-option
              v-for="item in users"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item><br>
      <el-form-item label="状态" prop="status" label-width="100px">
        <template>
          <el-select
            v-model="userForm.status"
            placeholder="请选择成员">
            <el-option
              v-for="item in sta"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item><br>

      <el-button @click="submitForm('userForm')" class="btn-submit1" style="margin-left:40px;margin-top:10px">确认</el-button>
    </el-form>

  </div>

</template>

<script>
import {addproject,getgroups,getUserList,getprojectbyid,updateproject} from "../../api/setting";
import { getdepts2} from "../../api/setting";
export default {
  name: 'children',
  inject:['reload'],
  data() {
    return {
      optionsname:'',
      options: [],
      user:localStorage.getItem('username'),
      id:this.$route.query.id,
      userForm:{
        name:'',
        group:'',
        remark:'',
        users:[parseInt(localStorage.getItem('userId'))],
        help:[],
        status:''
      },
      sta:[{
        id:0,
        name:'无'
      },{
        id:1,
        name:'洽谈中'
      },{
        id:2,
        name:'报告撰写'
      },{
        id:3,
        name:'售后服务'
      },{
        id:4,
        name:'项目受阻'
      },{
        id:5,
        name:'结束'
      },],
      //分组列表
      fenzu:[],
      //用户列表
      users:[],
      //  规则验证
      rules: {
        name: [{required: true, message: '请输入项目名称', trigger: 'change'}],
        group: [{required: true, message: '请选择所属分组', trigger: 'change'}],
        remark: [{required: true, message: '请输入描述内容', trigger: 'change'}],
        users: [{required: true, message: '请选择成员', trigger: 'change'}],
      },
    }
  },
  // 注册组件
  components: {

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //数据重新加载
    async re() {
      this.reload()
    },
    //单个项目
    getData(){
      let params={
        token:localStorage.getItem('token'),
        id:this.id
      }
      getprojectbyid(params).then(res=>{
          if (res.errno === 0) {
          this.userForm.name = res.data.name
          this.userForm.group = res.data.group_id
          this.userForm.remark = res.data.describe
          this.optionsname=res.data.dept_id
          this.userForm.users = res.data.user_ids == '' || res.data.user_ids == null ? [] : res.data.user_ids.split(',').map(Number)
            this.userForm.help = res.data.xietongren == '0' ? '请选择' : res.data.xietongren
            this.userForm.status = res.data.status
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      })
    },
    getData1(){
      let params={
        token: localStorage.getItem("token"),
        is_all:1
      }
      getdepts2(params).then(res=>{
         if (res.errno === 0) {
           this.options=res.data
           let item = {
             id:0,
             name:'全部数据'
           }
           this.options.push(item)
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      })
    },
    //提交
    submitForm(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          if (this.id==undefined||this.id=='') {
            let params={
              token:localStorage.getItem('token'),
              name:this.userForm.name,
              describe:this.userForm.remark,
              group_id:this.userForm.group,
              user_ids:(this.userForm.users).toString(),
              xietongren:parseInt(this.userForm.help == '请选择' || this.userForm.help == [] ? 0 : this.userForm.help),
              status:this.userForm.status,
              dept_id2:parseInt(this.optionsname)
            }

             addproject(params).then(res=>{
              if(res.errno===0){
                this.$message({
                  type:"success",
                  message:res.data
                })
                this.userForm = {}
                this.re()
                this.jumpClomn()
              }
              else if(res.errno===401){
                this.$store.dispatch('LogOut').then(() => {
                  location.reload() // 为了重新实例化vue-router对象 避免bug
                })
              }
              else{
                this.$message.error(res.error)
              }
            })
          }else{
            let params={
              id:this.id,
              token:localStorage.getItem('token'),
              name:this.userForm.name,
              describe:this.userForm.remark,
              group_id:this.userForm.group,
              xietongren:parseInt(this.userForm.help == '请选择' || this.userForm.help == [] ? 0 : this.userForm.help),
              user_ids:(this.userForm.users).toString(),
              status:this.userForm.status,
              dept_id2:parseInt(this.optionsname)
            }
            updateproject(params).then(res=>{
              if (res.errno === 0) {
                this.$message({
                  type: "success",
                  message: res.data,
                });
                 this.userForm = {}
                  this.re()
                this.jumpClomn()
              } else if (res.errno === 401) {
                this.$store.dispatch("LogOut").then(() => {
                  location.reload(); //为了重新实例化vue-router对象 避免bug
                });
              } else {
                this.$message.error(res.data);
              }
            })
          }
        }
      })
    },
    //获取用户列表
    getUser(){
      let params = {
        token: localStorage.getItem("token"),
        is_all:1
      };
      getUserList(params).then((res) => {
        if (res.errno === 0) {
          this.users = res.data
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取分组
    getGroup(){
      let params = {
        token: localStorage.getItem("token"),
        is_all:1
      };
      getgroups(params).then((res) => {
        if (res.errno === 0) {
          this.fenzu = res.data
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
    },
    jumpClomn(){
        this.$router.push({
        path: "/setting/setting",
      });
    }
  },
  created(){
    if (this.id!=undefined) {
      this.getData()
    }
  },
  mounted() {
    this.getGroup()
    this.getUser()
    this.getData1()
    // this.userForm.users.push(localStorage.getItem('userId'))

  }
}
</script>

<style scoped>
.navigations{
    padding: 20px 20px;
    background-color: #ffffff;
    height: 100%;
  }
  .navigations>>>.el-input__inner{
  width: 394px;
  height: 32px;
  color: #999999;
  border: 1px solid #cccccc;
}
/* .edit-dialog>>>.el-input__inner{
  width: 100%;
  height: 32px;
  border: 1px solid #cccccc;
} */
.navigations>>>.el-input__inner:hover,.edit-dialog>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
}
.navigations>>>.el-input__inner:focus,.edit-dialog>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
  color: #333333;
}
</style>





// WEBPACK FOOTER //
// src/views/setting/addproject.vue